import { getMediaBreakpoint } from '@boclips-ui/use-media-breakpoints';
import Pagination from '@boclips-ui/pagination';
import { List } from 'antd';
import Pageable from 'boclips-api-client/dist/sub-clients/common/model/Pageable';
import { ListViewCollection } from 'boclips-api-client/dist/sub-clients/collections/model/ListViewCollection';
import React from 'react';
import c from 'classnames';
import PlaylistCard from 'src/components/playlists/PlaylistCard';
import { PlaylistEmptyState } from 'src/components/playlists/emptyState/EmptyState';
import { useGetVideos } from 'src/hooks/api/videoQuery';
import s from '../style.module.less';
import paginationStyles from '../../common/pagination/pagination.module.less';

interface PlaylistListProps {
  playlists: Pageable<ListViewCollection>;
  page?: number;
  handlePageChange?: (newPage: number) => void;
  playlistType?: 'mine' | 'shared' | 'boclips';
}

export const PLAYLISTS_PAGE_SIZE = 20;

const PlaylistList: React.FC<PlaylistListProps> = ({
  playlists,
  page = 1,
  handlePageChange = () => {},
  playlistType,
}) => {
  const currentBreakpoint = getMediaBreakpoint();
  const mobileView = currentBreakpoint.type === 'mobile';

  const allThumbnailVideoIds = playlists.page.flatMap((playlist) =>
    playlist.assets.slice(0, 3).map((asset) => asset.id.videoId),
  );
  const { data: allThumbnailVideos } = useGetVideos(allThumbnailVideoIds);

  const itemRender = React.useCallback(
    (pageNumber: number, type: string) => (
      <Pagination
        buttonType={type}
        page={pageNumber}
        mobileView={mobileView}
        currentPage={page}
        totalItems={Math.ceil(
          playlists.pageSpec.totalElements / PLAYLISTS_PAGE_SIZE,
        )}
      />
    ),
    [mobileView, page, playlists?.pageSpec.totalPages],
  );

  return playlists?.page.length > 0 ? (
    <List
      data-qa="playlist-grid-container"
      className={s.gridView}
      pagination={{
        total: playlists.pageSpec.totalElements,
        className: c(paginationStyles.pagination, s.pagination, {
          [paginationStyles.paginationEmpty]: !playlists.page.length,
        }),
        hideOnSinglePage: true,
        pageSize: PLAYLISTS_PAGE_SIZE,
        showSizeChanger: false,
        onChange: handlePageChange,
        current: page,
        showLessItems: mobileView,
        prefixCls: 'bo-pagination',
        itemRender,
      }}
      dataSource={playlists.page}
      renderItem={(playlist: ListViewCollection) => {
        const playlistVideoIds = playlist.assets
          .slice(0, 3)
          .map((asset) => asset.id.videoId);
        const thumbnailVideos = allThumbnailVideos?.filter((video) =>
          playlistVideoIds.includes(video.id),
        );
        return (
          <PlaylistCard playlist={playlist} thumbnailVideos={thumbnailVideos} />
        );
      }}
    />
  ) : (
    <PlaylistEmptyState playlistType={playlistType} />
  );
};

export default PlaylistList;
